import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Logo variants
 */
export const logoVariants = cva(['inline-flex', 'shrink-0'], {
  variants: {
    size: {
      sm: ['h-[24px]'],
      md: ['h-[35px]'],
      lg: ['h-[48px]'],
    },
    inverted: {
      true: ['text-white'],
      false: ['text-brand'],
    },
  },
  defaultVariants: {
    size: 'md',
    inverted: false,
  },
});

export type LogoVariants = VariantProps<typeof logoVariants>;
